'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Divider = require('./Divider');

var _Divider2 = _interopRequireDefault(_Divider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Divider2.default;


/*****************
 ** WEBPACK FOOTER
 ** ../~/material-ui/Divider/index.js
 ** module id = 834
 ** module chunks = 3
 **/